@if (userProfile$ | async; as user) {
  <hr />
  <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 g-3 mb-4">
    <div class="col">
      <app-info-block
        label="First name"
        [value]="user.first_name"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Last name"
        [value]="user.last_name"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="South African identity number"
        [value]="maskService.idNumberMask(user.idnum)"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Email address"
        [value]="user.email"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Phone number"
        [value]="maskService.formatInternationalPhone(user.phone)"></app-info-block>
    </div>
  </div>
  <hr />
  <div class="mt-3 text-end">
    <a
      class="btn btn-primary"
      [routerLink]="'change-password'">
      Change password
    </a>
  </div>
} @else {
  <app-loader></app-loader>
}
